import { render } from "./VistaCursoInscrito.vue?vue&type=template&id=4b79b77e&scoped=true"
import script from "./VistaCursoInscrito.vue?vue&type=script&lang=js"
export * from "./VistaCursoInscrito.vue?vue&type=script&lang=js"

import "./VistaCursoInscrito.vue?vue&type=style&index=0&id=4b79b77e&scoped=true&lang=css"

import exportComponent from "D:\\WEB\\LICEO\\CURSOS\\portalalumnoscursos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b79b77e"]])

export default __exports__